import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, CloseButton, ConfirmationModal, CustomModal, FullBox, TextButton, Typography } from 'seagull';
import { ChevronLeft } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './ResponsiveModal.module.scss';
export const GetResponsiveModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ResponsiveModalTID: {
                PrimaryButton: 'confirmation-modal-primary-btn',
                SecondaryButton: 'confirmation-modal-secondary-btn'
            }
        }
    });
function isConfirmationModalProps(props) {
    return 'onPrimaryButtonClick' in props;
}
export function ResponsiveModal(props) {
    var _props_skin, _props_skin1;
    const { children, title, backTitle, mobileTitle = title, isMobile, onClose, testId, biName, openBottomSheetOnMobile } = props, rest = _object_without_properties(props, [
        "children",
        "title",
        "backTitle",
        "mobileTitle",
        "isMobile",
        "onClose",
        "testId",
        "biName",
        "openBottomSheetOnMobile"
    ]);
    const { ResponsiveModalTID } = useMemo(()=>GetResponsiveModalTID(testId), [
        testId
    ]);
    const showConfirmationVariant = !isMobile || openBottomSheetOnMobile === true;
    if (showConfirmationVariant) {
        if (isConfirmationModalProps(props)) {
            const { skin, primaryButtonDisabled, primaryButtonLabel, primaryButtonIntent, onPrimaryButtonClick, secondaryButtonLabel, onSecondaryButtonClick } = props;
            return /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread({
                bi: {
                    primaryButton: {
                        name: "".concat(biName, "_confirm")
                    },
                    secondaryButton: {
                        name: "".concat(biName, "_cancel")
                    }
                },
                testId: testId,
                textAlignCenter: false,
                openBottomSheetOnMobile: openBottomSheetOnMobile,
                content: children,
                title: title !== null && title !== void 0 ? title : '',
                skin: skin,
                onCloseButtonClick: onClose,
                primaryButtonIntent: primaryButtonIntent,
                primaryButtonDisabled: primaryButtonDisabled,
                primaryButtonLabel: primaryButtonLabel,
                onPrimaryButtonClick: onPrimaryButtonClick,
                secondaryButtonLabel: secondaryButtonLabel,
                onSecondaryButtonClick: onSecondaryButtonClick
            }, rest));
        } else {
            return /*#__PURE__*/ _jsx(CustomModal, _object_spread_props(_object_spread({
                bi: {
                    closeButton: {
                        name: "".concat(biName, "_close")
                    }
                },
                hideCloseBtn: true,
                maxWidth: 600,
                testId: testId,
                openBottomSheetOnMobile: openBottomSheetOnMobile
            }, rest), {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.customModal,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.customModalHeader,
                            children: [
                                /*#__PURE__*/ _jsx("div", {}),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    weight: "bold",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(CloseButton, {
                                        bi: {
                                            name: "close_".concat(biName)
                                        },
                                        skin: "transparent",
                                        onClick: onClose
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.customModalBody,
                            children: children
                        })
                    ]
                })
            }));
        }
    }
    return /*#__PURE__*/ _jsxs(FullBox, _object_spread_props(_object_spread({
        flexDirection: "column",
        className: styles.mobileModal,
        testId: testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.mobileModalHeader,
                children: /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: "".concat(biName, "_back")
                    },
                    skin: "secondary",
                    prefixIcon: /*#__PURE__*/ _jsx(ChevronLeft, {}),
                    underline: "hover",
                    onClick: onClose,
                    children: backTitle
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.mobileModalBody,
                children: [
                    mobileTitle && /*#__PURE__*/ _jsx(Typography, {
                        weight: "bold",
                        variant: "h6",
                        className: styles.mobileModalTitle,
                        children: mobileTitle
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.mobileModalFooter,
                children: isConfirmationModalProps(props) ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: "".concat(biName, "_confirm")
                            },
                            fluid: true,
                            size: "medium",
                            skin: "".concat((_props_skin = props.skin) !== null && _props_skin !== void 0 ? _props_skin : 'primary'),
                            onClick: props.onPrimaryButtonClick,
                            testId: ResponsiveModalTID.PrimaryButton(),
                            disabled: props.primaryButtonDisabled,
                            children: props.primaryButtonLabel
                        }),
                        props.secondaryButtonLabel && /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: "".concat(biName, "_cancel")
                            },
                            fluid: true,
                            size: "medium",
                            skin: "".concat((_props_skin1 = props.skin) !== null && _props_skin1 !== void 0 ? _props_skin1 : 'primary', "Outline"),
                            onClick: props.onSecondaryButtonClick,
                            testId: ResponsiveModalTID.SecondaryButton(),
                            children: props.secondaryButtonLabel
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: "close_".concat(biName)
                    },
                    fluid: true,
                    onClick: onClose,
                    children: "Back"
                })
            })
        ]
    }));
}
